import { render } from "./userManageCrud.vue?vue&type=template&id=25918a73"
import script from "./userManageCrud.vue?vue&type=script&lang=jsx"
export * from "./userManageCrud.vue?vue&type=script&lang=jsx"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__